import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  avaliacoesGlobaisService,
  type AvaliacoesGlobaisListResponse,
  type AvaliacoesGlobaisParams,
} from './services';

export const fetchAvaliacoesGlobais = createAsyncThunk<
  AvaliacoesGlobaisListResponse,
  AvaliacoesGlobaisParams | undefined,
  { rejectValue: string }
>('avaliacoesGlobais/fetchList', async (params, { rejectWithValue }) => {
  try {
    return await avaliacoesGlobaisService.list(params);
  } catch (error) {
    return rejectWithValue(error instanceof Error ? error.message : 'Erro ao carregar avaliações');
  }
});
